const MemberCornerModal = require('./lum-broker-member-corner-modal.js');

(($) => {
    const modals = [];

    $(document).on('ready', init);

    function init() {
        bind();
    }

    function bind() {
        $('html').on('bb-lumeris:lum-broker-member-corner:init', moduleInit);
    }

    function moduleInit(event, data) {
        if (!event || !data) {
            return false;
        }
        
        const $module = $(`.fl-node-${data.node}`);

        for (let i=1; i<3; i++) {
            for (let n in data.settings[`column${i}_items`]) {
                if (data.settings[`column${i}_items`][n].item_type !== 'download' || data.settings[`column${i}_items`][n].download_type !== 'modal') {
                    continue;
                }

                const modal = new MemberCornerModal({
                    $module: $module,
                    moduleData: data,
                    modalData: data.settings[`column${i}_items`][n],
                    modalId: `modal_${data.node}_${i}_${n}`
                });
                modals.push(modal);
            }
        }
    }
})(jQuery);